import { useMutation } from "@tanstack/react-query";
import * as api from "./request";

export function useDownloadS3File(onSuccess?: any, onError?: any) {
    const { mutate: downloadS3File, error, isLoading, data } = useMutation(
        ['downloadS3File'],
        async (params: { s3_region: string; s3_bucket: string; s3_key: string; authorized_user?: string }) => 
            await api.get('/api/v1/s3_files/download', params, null, { responseType: 'blob' }),
        {
            onSuccess,
            onError
        }
    );
    
    return { 
        downloadS3File, 
        error, 
        isLoading, 
        data 
    };
}

// Direct API call function for use in utility functions
export async function downloadS3File(params: { s3_region: string; s3_bucket: string; s3_key: string; authorized_user?: string }) {
    return await api.get('/api/v1/s3_files/download', params, null, { responseType: 'blob' });
}